import { sendPasskeyLoginRequest } from "./ext_packet";

export function initWebAuthn() {
  document.getElementById("use_passkey").addEventListener("click", () => {
    sendPasskeyLoginRequest();
  });
}
